var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form__description text-center"},[_vm._v(" Choose your size, color, and options when applicable... ")])
}
var staticRenderFns = []

export { render, staticRenderFns }